import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "@aureskonnect/react-ui";

import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { ActionColumnModeSale } from "./ActionColumnModeSale";
import "./index.css";

interface Props {
    modify: boolean;
    modalState: any;
    setModalState: Function;
    handleAddSalesMethodClick: () => void;
    isModeOfSaleArchived: boolean;
    isLoading: boolean;
    sale: any[];
    isEdited: boolean;
    setInputSaleMode: (val: boolean) => void;
    setSelectName: (val: boolean) => void;
    setSelectSales: (val: boolean) => void;
    selectedRows: any[];
    setSelectedRows: (rows: any[]) => void;
    setDataIsUpdated: (val: boolean | number) => void;
    setIsModeOfSaleArchived: (val: boolean) => void;
    setLimit: (val: number) => void;
}

const SalesMethodHeaderActions: React.FC<Props> = ({
    modify,
    modalState,
    setModalState,
    handleAddSalesMethodClick,
    isModeOfSaleArchived,
    isLoading,
    sale,
    isEdited,
    setInputSaleMode,
    setSelectName,
    setSelectSales,
    selectedRows,
    setSelectedRows,
    setDataIsUpdated,
    setIsModeOfSaleArchived,
    setLimit,
}) => {
    const { t } = useTranslation();

    if (!modify) return null;

    return (
        <div className="d-flex justify-content-start align-items-center ml-2">
            <>
                {modalState.isAddModeOfSaleClicked !== true ? (
                    <span
                        onClick={handleAddSalesMethodClick}
                        className={classnames("w-100 cmn_btn_openForm", {
                            "not-allowed-icon__clz":
                                isModeOfSaleArchived || isLoading,
                        })}
                    >
                        <CustomMainColorButtonWithIcon
                            icon="PlusIcon"
                            iconPosition="left"
                            rounded
                            variant="primary"
                        >
                            {t("Add a sales method")}
                        </CustomMainColorButtonWithIcon>
                    </span>
                ) : (
                    <CustomMainColorIconButton
                        icon="PlusIcon"
                        className="mdv_btn_FRreset"
                        rounded
                        disabled={sale.length !== 0}
                        onClick={() => {
                            if (isEdited) {
                                setModalState((prev: any) => ({
                                    ...prev,
                                    isInInitializationModalOpened: true,
                                }));
                            } else {
                                setInputSaleMode(false);
                                setSelectSales(false);
                                setSelectName(false);
                            }
                        }}
                    >
                        <PlusIcon height={20} width={20} fill="white" />
                    </CustomMainColorIconButton>
                )}
            </>
            <ActionColumnModeSale
                selectedRows={selectedRows}
                setDataIsUpdated={setDataIsUpdated}
                setIsModeOfSaleArchived={setIsModeOfSaleArchived}
                isModeOfSaleArchived={isModeOfSaleArchived}
                setLimit={setLimit}
                setSelectedRows={setSelectedRows}
                setModalState={setModalState}
                isHistoryModalOpened={modalState.isHistoryModalOpened}
            />
        </div>
    );
};

export default SalesMethodHeaderActions;
